// extracted by mini-css-extract-plugin
module.exports = {"navigateLink":"NavigateBackLinkAsButton-module--navigateLink--4dfaf8"};